<nav role="navigation">
    <ul class="language-switcher-locale-url nav navbar-nav navbar-right" role="menu">
      <ul class="language-switcher-locale-url">
        <li class="ar first" [class.active]="lang === 'ar'"><a [class.active]="lang === 'ar'"
            class="language-link" (click)="changeLang('ar')" xml:lang="ar" role="menuitem">العربية</a>
        </li>
        <li class="zh-hans" [class.active]="lang === 'zh'"><a [class.active]="lang === 'zh'"
            class="language-link" (click)="changeLang('zh')" xml:lang="zh-hans" role="menuitem">中文</a></li>
        <li class="en" [class.active]="lang === 'en'"><a (click)="changeLang('en')" class="language-link"
            [class.active]="lang === 'en'" xml:lang="en" role="menuitem">English</a></li>
        <li class="fr" [class.active]="lang === 'fr'"><a (click)="changeLang('fr')" class="language-link"
            [class.active]="lang === 'fr'" xml:lang="fr" role="menuitem">Français</a></li>
        <li class="ru" [class.active]="lang === 'ru'"><a [class.active]="lang === 'ru'"
            class="language-link" (click)="changeLang('ru')" xml:lang="ru" role="menuitem">Русский</a></li>
        <li class="es last" [class.active]="lang === 'es'"><a [class.active]="lang === 'es'"
            class="language-link" (click)="changeLang('es')" xml:lang="es" role="menuitem">Español</a></li>
      </ul>
    </ul>
  </nav>
